import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { BreadcrumbService } from './breadcrumbs.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { DividerImgComponent } from '@shared/divider-img/divider-img.component';

@Component({
    selector: 'companyid-breadcrumbs',
    imports: [RouterLinkWithHref, ContentWrapperComponent, NgOptimizedImage, AssetPipe, DividerImgComponent],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnInit {
    private readonly breadcrumbService = inject(BreadcrumbService);

    public readonly breadcrumbs = toSignal(this.breadcrumbService.breadcrubms$);

    public ngOnInit(): void {
        this.breadcrumbService.getBreadcrumbs();
    }
}
